import React from "react";
import { HIDE_ON_EXPORT } from "../lib/downloadPage";
import ButtonIcon from "../ButtonIconV2";
import { MenuLine } from "../IconV2/react";

interface HamburgerButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  active: boolean;
  width?: number;
  height?: number;
}

const HamburgerButton = (
  { active, className, ...props }: HamburgerButtonProps,
  buttonRef: React.Ref<HTMLButtonElement>,
) => (
  <ButtonIcon ref={buttonRef} className={HIDE_ON_EXPORT} theme="dark" {...props}>
    <MenuLine size="m" />
  </ButtonIcon>
);

export default React.memo(React.forwardRef(HamburgerButton));
